<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Tài khoản chưa liên kết SHB
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="12">
                    <el-form-item label="Mã tài khoản DD hoặc tên điểm đến">
                      <el-input
                        v-model="mData.keyword"
                        placeholder="Nhập mã tài khoản DD hoặc tên điểm đến"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right mb-2">
              <el-button @click="fn_goBack()" type="info" plain>
                {{ aLang.c_back }}
              </el-button>
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          v-loading="mData.loading"
          element-loading-text="Đang tải dữ liệu..."
          :data="mData.tableRules.data"
          border
          max-height="484"
          style="width: 100%"
        >
          <el-table-column label="STT" align="center" width="60">
            <template slot-scope="scope">
              {{ mData.paging.offset + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="du_lieu_khai_bao.user_account"
            label="Mã số tài khoản"
            align="center"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="du_lieu_khai_bao.user_dien_thoai"
            label="Số điện thoại"
            align="center"
            width="140"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{
                  (scope.row.du_lieu_khai_bao
                    ? scope.row.du_lieu_khai_bao.user_dien_thoai
                    : "") | numberFormat
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="thong_tin_chung.ten"
            label="Tên điểm đến"
            min-width="180"
          ></el-table-column>
          <el-table-column
            prop="thong_tin_chung.giay_to.so_giay_to"
            :label="aLang.sd_tax_code"
            min-width="140"
          ></el-table-column>
          <el-table-column
            prop="thong_tin_chung.dia_chi.dia_chi"
            :label="aLang.sd_address"
            min-width="200"
          ></el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="90">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_lienKet(scope.$index, scope.row)"
                v-b-popover.hover.left="'Liên kết'"
              >
                <i class="fa fa-link"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2">
          <div class="col-md-12 text-right">
            <el-button-group>
              <el-button
                icon="el-icon-arrow-left"
                :disabled="mData.paging.offset === 0 || mData.loading"
                @click="fn_prevPage()"
                v-b-popover.hover.top="'Trang trước'"
              ></el-button>
              <el-button
                icon="el-icon-arrow-right"
                :disabled="!mData.paging.hasNext || mData.loading"
                @click="fn_nextPage()"
                style="margin-left: 10px"
                v-b-popover.hover.top="'Trang sau'"
              ></el-button>
            </el-button-group>
          </div>
        </b-row>
      </div>
    </div>

    <!-- Dialog liên kết SHB -->
    <el-dialog
      title="Liên kết tài khoản SHB"
      :visible.sync="mData.dialogLienKet.visible"
      width="720px"
      :close-on-click-modal="false"
      top="8vh"
      custom-class="dialog-lien-ket-shb"
    >
      <div class="dialog-lien-ket-inner">
        <!-- Khối thông tin điểm đến -->
        <div class="info-diem-den-box">
          <div class="info-item">
            <span class="info-item-label">Mã điểm đến:</span>
            <span class="info-item-value code">
              {{ mData.dialogLienKet.maDiemDen }}
            </span>
          </div>
          <div class="info-item">
            <span class="info-item-label">Tên điểm đến:</span>
            <span class="info-item-value">
              {{ mData.dialogLienKet.tenDiemDen }}
            </span>
          </div>
        </div>

        <el-form
          ref="formLienKet"
          label-position="top"
          :model="mData.dialogLienKet.form"
          :rules="mData.dialogLienKet.rules"
          @submit.native.prevent
        >
          <el-form-item class="form-item-token">
            <template slot="label">
              <span class="label-title">Token SHB</span>
              <span class="required-star">*</span>
            </template>
            <el-input
              v-model="mData.dialogLienKet.token"
              placeholder="Nhập Token SHB"
              prefix-icon="el-icon-key"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item class="form-item-checkbox">
            <el-checkbox v-model="mData.dialogLienKet.trichNoTuDong">
              <span class="checkbox-label">Đã đăng ký trích nợ tự động</span>
            </el-checkbox>
          </el-form-item>

          <div class="shb-thuho-title">Cấu hình SHB thu hộ</div>

          <b-row>
            <b-col md="6">
              <el-form-item label="Mã số thuế" prop="SHB_THUHO_TaxNo">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_TaxNo"
                  placeholder="Nhập Mã số thuế"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Số tài khoản" prop="SHB_THUHO_AccountNo">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_AccountNo"
                  placeholder="Nhập Số tài khoản"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Prefix alias account" prop="SHB_THUHO_Prefix">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_Prefix"
                  placeholder="Nhập Prefix alias account"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="ClientId" prop="SHB_THUHO_ClientId">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_ClientId"
                  placeholder="Nhập ClientId"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="ClientSecret" prop="SHB_THUHO_ClientSecret">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_ClientSecret"
                  placeholder="Nhập ClientSecret"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Username" prop="SHB_THUHO_Username">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_Username"
                  placeholder="Nhập Username"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Password" prop="SHB_THUHO_Password">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_Password"
                  type="password"
                  placeholder="Nhập Password"
                  show-password
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="ConsumerKey" prop="SHB_THUHO_ConsumerKey">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_ConsumerKey"
                  placeholder="Nhập ConsumerKey"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item
                label="ConsumerSecret"
                prop="SHB_THUHO_ConsumerSecret"
              >
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_ConsumerSecret"
                  placeholder="Nhập ConsumerSecret"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="SaleTypeCd" prop="SHB_THUHO_SaleTypeCd">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_SaleTypeCd"
                  placeholder="Nhập SaleTypeCd"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="ProvinceCd" prop="SHB_THUHO_ProvinceCd">
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_ProvinceCd"
                  placeholder="Nhập ProvinceCd"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col md="6">
              <el-form-item
                label="Thời gian hiệu lực alias/QR (giây)"
                prop="SHB_THUHO_ReqTime"
              >
                <el-input
                  v-model="mData.dialogLienKet.form.SHB_THUHO_ReqTime"
                  placeholder="Mặc định 900"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col> -->
          </b-row>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="mData.dialogLienKet.loading"
          @click="mData.dialogLienKet.visible = false"
          >Hủy</el-button
        >
        <el-button
          type="primary"
          icon="fa fa-link"
          :loading="mData.dialogLienKet.loading"
          :disabled="isDisableBtnLienKet || mData.dialogLienKet.loading"
          @click="fn_submitLienKet()"
        >
          Liên kết
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DiemDenAnToanModel from "../DiemDenAnToan/DiemDenAnToanModel";
import mushroom from "../../../service/api/dulich-api";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "LienKetNganHangSHB",
        keyword: "",
        loading: false,
        paging: {
          limit: 10,
          offset: 0,
          hasNext: false,
        },
        tableRules: MethodService.copyObject(DiemDenAnToanModel.tableRules),
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        dialogLienKet: {
          visible: false,
          loading: false,
          row: null,
          maDiemDen: "",
          tenDiemDen: "",
          token: "",
          trichNoTuDong: true,
          form: {
            SHB_THUHO_TaxNo: "",
            SHB_THUHO_AccountNo: "",
            SHB_THUHO_Prefix: "",
            SHB_THUHO_ClientId: "",
            SHB_THUHO_ClientSecret: "",
            SHB_THUHO_Username: "",
            SHB_THUHO_Password: "",
            SHB_THUHO_ConsumerKey: "",
            SHB_THUHO_ConsumerSecret: "",
            SHB_THUHO_SaleTypeCd: "",
            SHB_THUHO_ProvinceCd: "",
            // SHB_THUHO_ReqTime: "",
          },
          rules: {
            SHB_THUHO_TaxNo: [
              {
                required: true,
                message: "Vui lòng nhập Mã số thuế SHB thu hộ",
                trigger: "blur",
              },
            ],
            SHB_THUHO_AccountNo: [
              {
                required: true,
                message: "Vui lòng nhập Số tài khoản SHB thu hộ",
                trigger: "blur",
              },
            ],
            SHB_THUHO_Prefix: [
              {
                required: true,
                message: "Vui lòng nhập Prefix alias account",
                trigger: "blur",
              },
            ],
            SHB_THUHO_ClientId: [
              {
                required: true,
                message: "Vui lòng nhập ClientId",
                trigger: "blur",
              },
            ],
            SHB_THUHO_ClientSecret: [
              {
                required: true,
                message: "Vui lòng nhập ClientSecret",
                trigger: "blur",
              },
            ],
            SHB_THUHO_Username: [
              {
                required: true,
                message: "Vui lòng nhập Username",
                trigger: "blur",
              },
            ],
            SHB_THUHO_Password: [
              {
                required: true,
                message: "Vui lòng nhập Password",
                trigger: "blur",
              },
            ],
            SHB_THUHO_ConsumerKey: [
              {
                required: true,
                message: "Vui lòng nhập ConsumerKey",
                trigger: "blur",
              },
            ],
            SHB_THUHO_ConsumerSecret: [
              {
                required: true,
                message: "Vui lòng nhập ConsumerSecret",
                trigger: "blur",
              },
            ],
            SHB_THUHO_SaleTypeCd: [
              {
                required: true,
                message: "Vui lòng nhập SaleTypeCd",
                trigger: "blur",
              },
            ],
            SHB_THUHO_ProvinceCd: [
              {
                required: true,
                message: "Vui lòng nhập ProvinceCd",
                trigger: "blur",
              },
            ],
          },
        },
      },
    };
  },
  filters: {
    numberFormat: function (value) {
      if (!value) return "";
      if (value.length == 11) {
        return value.replace(/^\d{2}/, "0");
      }
      return value;
    },
  },
  computed: {
    isDisableBtnLienKet() {
      let token = this.mData.dialogLienKet.token;
      let isTrichNo = this.mData.dialogLienKet.trichNoTuDong;
      if (!token || !token.trim() || !isTrichNo) {
        return true;
      }
      // Các trường cấu hình SHB thu hộ bắt buộc (trừ SHB_THUHO_ReqTime)
      const form = this.mData.dialogLienKet.form;
      const requiredFields = [
        "SHB_THUHO_TaxNo",
        "SHB_THUHO_AccountNo",
        "SHB_THUHO_Prefix",
        "SHB_THUHO_ClientId",
        "SHB_THUHO_ClientSecret",
        "SHB_THUHO_Username",
        "SHB_THUHO_Password",
        "SHB_THUHO_ConsumerKey",
        "SHB_THUHO_ConsumerSecret",
        "SHB_THUHO_SaleTypeCd",
        "SHB_THUHO_ProvinceCd",
      ];
      return requiredFields.some(
        (key) => !form[key] || !form[key].toString().trim()
      );
    },
  },
  methods: {
    async fn_initTable() {
      let params = {
        keyword: this.mData.keyword ? this.mData.keyword.trim() : "",
        limit: this.mData.paging.limit,
        offset: this.mData.paging.offset,
      };

      this.mData.loading = true;
      try {
        let res =
          await mushroom.diem_den_an_toan.views.ddat_not_linked_shb_merchant_tokenAsync(
            params,
            { enabledCache: false }
          );
        let result = res.result || [];
        this.mData.tableRules.data = result;

        this.mData.paging.hasNext = result.length === this.mData.paging.limit;
      } catch (e) {
        console.log("error", e);
        this.$message({
          message:
            (e && e.message) ||
            "Không thể tải danh sách tài khoản chưa liên kết SHB!",
          type: "error",
        });
      } finally {
        this.mData.loading = false;
      }
    },

    fn_tableSearch() {
      this.mData.keyword = this.mData.keyword ? this.mData.keyword.trim() : "";
      this.mData.paging.offset = 0;
      this.fn_initTable();
      MethodService.stopLadda();
    },

    // Trang trước
    fn_prevPage() {
      if (this.mData.paging.offset === 0) return;
      this.mData.paging.offset = Math.max(
        0,
        this.mData.paging.offset - this.mData.paging.limit
      );
      this.fn_initTable();
    },

    // Trang sau
    fn_nextPage() {
      if (!this.mData.paging.hasNext) return;
      this.mData.paging.offset += this.mData.paging.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    // Kiểm tra 1 tài khoản điểm đến an toàn đã khai báo đầy đủ thông tin chưa
    fn_checkDaKhaiBaoDayDu(diemDen) {
      if (
        !diemDen ||
        !diemDen.du_lieu_khai_bao ||
        !diemDen.du_lieu_khai_bao.ho_ten ||
        !diemDen.du_lieu_khai_bao.chuc_vu ||
        !diemDen.du_lieu_khai_bao.giay_to_so_giay_to ||
        !diemDen.du_lieu_khai_bao.user_ten ||
        !diemDen.du_lieu_khai_bao.user_loai ||
        !diemDen.du_lieu_khai_bao.dia_chi_tinh_id ||
        !diemDen.du_lieu_khai_bao.dia_chi_xa_id ||
        !diemDen.du_lieu_khai_bao.user_dia_chi
      ) {
        return false;
      }
      return true;
    },

    // Liên kết tài khoản với SHB
    fn_lienKet(index, row) {
      if (!this.fn_checkDaKhaiBaoDayDu(row)) {
        this.$confirm(
          "Tài khoản điểm đến này chưa khai báo đầy đủ thông tin, vui lòng khai báo trước khi truy cập tính năng này.",
          {
            confirmButtonText: "Chuyển tới trang khai báo",
            cancelButtonText: "Hủy",
            type: "warning",
          }
        )
          .then(() => {
            this.$router.push({
              name: "Admin-DiemDenAnToan-update",
              params: { id: row.id },
            });
          })
          .catch(() => {});
        return;
      }

      this.mData.dialogLienKet.visible = true;
      this.mData.dialogLienKet.loading = false;
      this.mData.dialogLienKet.row = row;
      this.mData.dialogLienKet.maDiemDen =
        (row.du_lieu_khai_bao && row.du_lieu_khai_bao.user_account) ||
        row.user_account ||
        "";
      this.mData.dialogLienKet.tenDiemDen =
        (row.thong_tin_chung && row.thong_tin_chung.ten) ||
        (row.du_lieu_khai_bao && row.du_lieu_khai_bao.user_ten) ||
        "";
      this.mData.dialogLienKet.token = "";
      this.mData.dialogLienKet.trichNoTuDong = true;
      this.mData.dialogLienKet.form = {
        SHB_THUHO_TaxNo: "",
        SHB_THUHO_AccountNo: "",
        SHB_THUHO_Prefix: "",
        SHB_THUHO_ClientId: "",
        SHB_THUHO_ClientSecret: "",
        SHB_THUHO_Username: "",
        SHB_THUHO_Password: "",
        SHB_THUHO_ConsumerKey: "",
        SHB_THUHO_ConsumerSecret: "",
        SHB_THUHO_SaleTypeCd: "",
        SHB_THUHO_ProvinceCd: "",
        // SHB_THUHO_ReqTime: "",
      };
      // Xóa trạng thái validate cũ khi mở lại dialog
      this.$nextTick(() => {
        if (this.$refs.formLienKet) {
          this.$refs.formLienKet.clearValidate();
        }
      });
    },

    // Xử lý xác nhận liên kết SHB từ dialog
    async fn_submitLienKet() {
      // Validate các trường cấu hình SHB thu hộ bắt buộc trước khi gửi
      const valid = await this.$refs.formLienKet
        .validate()
        .catch(() => false);
      if (!valid) {
        return;
      }

      const form = this.mData.dialogLienKet.form;
      // SHB_THUHO_ReqTime không bắt buộc, mặc định gửi lên 900 nếu bỏ trống
      // const reqTime =
      //   form.SHB_THUHO_ReqTime && form.SHB_THUHO_ReqTime.toString().trim()
      //     ? form.SHB_THUHO_ReqTime.toString().trim()
      //     : "900";

      this.mData.dialogLienKet.loading = true;
      try {
        const res = await mushroom.shb_card.create_cardAsync({
          body: {
            user_id: this.mData.dialogLienKet.row.du_lieu_khai_bao.user_id,
            account: this.mData.dialogLienKet.maDiemDen,
            token: this.mData.dialogLienKet.token,
            debitInfo: true,
            SHB_THUHO_TaxNo: form.SHB_THUHO_TaxNo.trim(),
            SHB_THUHO_AccountNo: form.SHB_THUHO_AccountNo.trim(),
            SHB_THUHO_Prefix: form.SHB_THUHO_Prefix.trim(),
            SHB_THUHO_ClientId: form.SHB_THUHO_ClientId.trim(),
            SHB_THUHO_ClientSecret: form.SHB_THUHO_ClientSecret.trim(),
            SHB_THUHO_Username: form.SHB_THUHO_Username.trim(),
            SHB_THUHO_Password: form.SHB_THUHO_Password,
            SHB_THUHO_ConsumerKey: form.SHB_THUHO_ConsumerKey.trim(),
            SHB_THUHO_ConsumerSecret: form.SHB_THUHO_ConsumerSecret.trim(),
            SHB_THUHO_SaleTypeCd: form.SHB_THUHO_SaleTypeCd.trim(),
            SHB_THUHO_ProvinceCd: form.SHB_THUHO_ProvinceCd.trim(),
            // SHB_THUHO_ReqTime: reqTime,
          },
        });
        console.log("result", res);
        let result = res && res.result;
        if (result && (result.success === true || result === true)) {
          // Đóng dialog ngay trước khi tải lại bảng để hiển thị spinner loading cho người dùng
          this.mData.dialogLienKet.visible = false;
          this.$message({
            message: "Liên kết tài khoản với ngân hàng SHB thành công!",
            type: "success",
          });
          // Xóa cache của danh sách điểm đến để đảm bảo lấy dữ liệu mới từ backend
          mushroom.diem_den_an_toan.invalidCache();
          await this.fn_initTable();
          this.$router.push({
            name: "Admin-LienKetNganHangSHB",
          });
        }
      } catch (e) {
        console.log("error", e);
        if (e && e.code === 400) {
          if (e.meta && e.meta.field === "user_id") {
            this.$message({
              message: "Tài khoản điểm đến đã liên kết với ngân hàng SHB!",
              type: "error",
            });
          } else if (e.meta && e.meta.field === "token") {
            this.$message({
              message: "Token SHB không hợp lệ hoặc đã hết hạn!",
              type: "error",
            });
          } else if (e.meta && e.meta.field === "account") {
            this.$message({
              message: "Mã tài khoản không hợp lệ hoặc đã được liên kết!",
              type: "error",
            });
          } else if (e.meta && e.meta.field === "debitInfo") {
            this.$message({
              message: "Thông tin trích nợ tự động không hợp lệ!",
              type: "error",
            });
          } else {
            this.$message({
              message: e.message || "Dữ liệu yêu cầu không hợp lệ!",
              type: "error",
            });
          }
        } else {
          this.$message({
            message:
              (e && e.message) ||
              "Có lỗi xảy ra khi liên kết với ngân hàng SHB!",
            type: "error",
          });
        }
      } finally {
        this.mData.dialogLienKet.loading = false;
      }
    },

    // Quay lại màn danh sách liên kết SHB
    fn_goBack() {
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
      });
    },
  },

  created() {
    this.fn_initTable();
  },
};
</script>

<style
  lang="scss"
  scoped
  src="./LienKetNganHangSHBChuaLienKetList.scss"
></style>
